// Wiederverwendbare Schema.org-Bausteine für strukturierte Daten (JSON-LD).
// Organization/WebSite liegen statisch in public/index.html; hier kommen die
// seitenspezifischen Schemas dazu.

export const SITE_ORIGIN = "https://www.adsfux.de";
export const ORG_ID = `${SITE_ORIGIN}/#organization`;

/** BreadcrumbList aus einer Liste [{ name, path }]. */
export function breadcrumb(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      item: `${SITE_ORIGIN}${item.path === "/" ? "/" : item.path.replace(/\/$/, "")}`,
    })),
  };
}

/** Service-Schema mit Anbieter-Referenz auf die Organization. */
export function service({ name, description, path, serviceType }) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name,
    description,
    serviceType,
    url: `${SITE_ORIGIN}${path}`,
    provider: { "@id": ORG_ID },
    areaServed: { "@type": "Country", name: "Deutschland" },
    inLanguage: "de-DE",
  };
}

/** FAQPage aus [{ q, a }]. */
export function faqPage(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}
